import { posthog } from './posthog';

/**
 * Reports Web Vitals metrics to PostHog if available
 * This helps track Core Web Vitals: LCP, FID, CLS, FCP, TTFB
 */
export function reportWebVitals() {
  if (typeof window === 'undefined') return;

  // Only report if PostHog is initialized
  if (!posthog.__loaded) return;

  // Use Next.js web-vitals reporting if available
  if ('web-vitals' in window) {
    return;
  }

  // Dynamically import web-vitals library
  import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
    // Core Web Vitals
    onCLS((metric) => {
      posthog.capture('web_vital', {
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
      });
    });

    onINP((metric) => {
      posthog.capture('web_vital', {
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
      });
    });

    onLCP((metric) => {
      posthog.capture('web_vital', {
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
      });
    });

    // Additional metrics
    onFCP((metric) => {
      posthog.capture('web_vital', {
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
      });
    });

    onTTFB((metric) => {
      posthog.capture('web_vital', {
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
      });
    });
  }).catch(() => {
    // Silently fail if web-vitals is not available
  });
}
